import { useNavigate } from 'react-router-dom';
import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  useMediaQuery,
} from '@mui/material';

import { resultadoService } from '../../Services/Form';
import { IUserFromStorage } from '../../Interfaces/IUser';
import { Tr4inerOutlinedButton } from '../../Utils/Button';
import { subirControlFotos } from '../../Services/FotoLlenado';
import { abrirModalConfirmarEvaluacion, IEvaluacion } from './constants';
import Loading from '../../Utils/Loading';
import control from '../ModalLlenarPesosResultado/constants';
import ComidasSection from './EvaluacionSections/ComidasSection';
import FotosEvaluacion from './EvaluacionComponents/FotosEvaluacion';
import ModalCloseDialog from './EvaluacionComponents/ModalCloseDialog';
import EntrenamientoSection from './EvaluacionSections/EntrenamientoSection';
import PesoPorcentajeSection from './EvaluacionSections/PesoPorcentajeSection';
import ModalConfirmarEvaluacion from './ModalConfirmarEvaluacion/ModalConfirmarEvaluacion';

import CloseIcon from '@mui/icons-material/Close';

import './modalEvaluacion.css'
// import UploadVideoEvaluation from './UploadVideoEvaluation/UploadVideoEvaluation';
// import { IResultado } from '../../Interfaces/IResultado';
// import Divider from '../Divider';
// import FControlLabel from '../shared/Forms/FControlLabel';


interface Props {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

function ModalEvaluacion({ isOpen, setIsOpen }: Props) {
  const [files, setFiles] = useState<any[]>([]);
  const [imgBase64Data, setImgBase64Data] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isOpenModalConfirmar, setIsOpenModalConfirmar] = useState<boolean>(false);
  const [isOpenModalCloseDialog, setIsOpenModalCloseDialog] = useState<boolean>(false);
  const [objetivoActual, setObjetivoActual] = useState<string>('');
  const [section, setSection] = useState<number>(0);
  const [currentPhase, setCurrentPhase] = useState<string>('Nivel 1');
  // const [dataRes, setDataRes] = useState<IResultado>();

  const [dataEvaluacion, setDataEvaluacion] = useState<IEvaluacion>({
    peso: 0,
    porcentajeGrasa: 15,
    unidadPeso: 'Kg',
    tipoActividad: '1',
    objetivo: null,
    estaturaReal: 0,
    sedeID: 22,
    mes: 1,
    cantidadComidas: 3,
    cantidadDiasEntrenamiento: 2,
    tiempoEntrenamiento: 'C',
    diasPrioridad: 2,
  });

  const disabledButton = () => {
    if (isLoading) {
      return true;
    } else {
      return false;
    }
  }

  const navigate = useNavigate();

  const sexo : boolean = localStorage.getItem('sexoUser') ? JSON.parse(localStorage.getItem('sexoUser')) : true;

  const user: IUserFromStorage = JSON.parse(localStorage.getItem('user'));

  const isMobile = useMediaQuery("(max-width:768px)");

  const contentRef = useRef<HTMLDivElement>(null);

  function handleChange(type: string, value: string | number) {
    switch (type) {
      case 'peso':
        setDataEvaluacion((prev) => ({
          ...prev,
          peso: Number(value),
        }));
        break;
      case 'porcentajeGrasa':
        setDataEvaluacion((prev) => ({
          ...prev,
          porcentajeGrasa: Number(value),
        }));
        break;
      case 'unidadPeso':
        setDataEvaluacion((prev) => ({
          ...prev,
          unidadPeso: String(value),
        }));
        break;
      case 'tipoActividad':
        setDataEvaluacion((prev) => ({
          ...prev,
          tipoActividad: String(value),
        }));
        break;
      case 'objetivo':
        setDataEvaluacion((prev) => ({
          ...prev,
          objetivo: String(value),
        }));
        break;
      case 'sedeID':
        setDataEvaluacion((prev) => ({
          ...prev,
          sedeID: Number(value),
        }));
        break;
      case 'cantidadComidas':
        setDataEvaluacion((prev) => ({
          ...prev,
          cantidadComidas: Number(value),
        }));
        break;
      case 'cantidadDiasEntrenamiento':
        setDataEvaluacion((prev) => ({
          ...prev,
          cantidadDiasEntrenamiento: Number(value),
        }));
        break;
      case 'tiempoEntrenamiento':
        setDataEvaluacion((prev) => ({
          ...prev,
          tiempoEntrenamiento: String(value),
        }));
        break;
      case 'diasPrioridad':
        setDataEvaluacion((prev) => ({
          ...prev,
          diasPrioridad: Number(value),
        }));
        break;
      default:
        break;
    }
  }

  useEffect(() => {
    setIsLoading(true);
    resultadoService({
      UsuarioTestAsesoriaID: user.usuarioTestAsesoriaID
    })
      .then((res) => {
        setCurrentPhase(res.data.data.fase);
        // setDataRes(res.data.data);
        setDataEvaluacion({
          peso: 0,
          porcentajeGrasa: 15,
          unidadPeso: res.data.data.unidadPeso,
          tipoActividad: res.data.data.tipoActividad,
          objetivo: null,
          estaturaReal: res.data.data.estaturaReal,
          sedeID: res.data.data.sedeID,
          mes: res.data.data.mes,
          cantidadComidas: 3,
          cantidadDiasEntrenamiento: 3,
          tiempoEntrenamiento: 'C',
          diasPrioridad: 0,
        });
        setObjetivoActual(res.data.data.objetivoAbreviado);
      })
      .finally(() => {
        setIsLoading(false);
      })
        // console.log(dataEvaluacion);
  }, [])

  function sendData() {
    // if (files.length < 3) {
    //   toast.error('Tienen que ser mínimo 3 imágenes 😢.');
    //   return;
    // }

    setIsLoading(true);
    subirControlFotos({
      Fotos:                  imgBase64Data,
      Peso:                   dataEvaluacion.peso,
      PorcentajeGrasa:        dataEvaluacion.porcentajeGrasa,                                                                
      UnidadPeso:             dataEvaluacion.unidadPeso,
      TipoActividad:          dataEvaluacion.tipoActividad,
      Objetivo:               dataEvaluacion.objetivo,
      EstaturaReal:           dataEvaluacion.estaturaReal,
      SedeID:                 dataEvaluacion.sedeID,
      Mes:                    dataEvaluacion.mes,
      CantidadComidas:        dataEvaluacion.cantidadComidas,
      UsuarioTestAsesoriaID:  user ? user.usuarioTestAsesoriaID : 0,
      CantidadDias:           dataEvaluacion.cantidadDiasEntrenamiento,
      PrioridadDias:          dataEvaluacion.cantidadDiasEntrenamiento === 5 ? 0 : dataEvaluacion.diasPrioridad,
      TiempoRutina:           dataEvaluacion.tiempoEntrenamiento,
    })
      .then(() => {
        toast.success('Datos enviados correctamente.');
          window.location.reload();
          setIsOpen(false);
      })
      .catch((err) => {
        toast.error('Sucedió un error, por favor, vuelve a intentarlo')
        console.error(err);
      })
      .finally(() => setIsLoading(false));
  }

  // function pruebaDeFuego() {
  //   setIsLoading(true)
  //   setTimeout(() => {
  //     console.log(imgBase64Data);
  //     console.log(dataEvaluacion);
  //     toast.success('Datos enviados correctamente.');
  //     setIsLoading(false);
  //     setIsOpen(false);
  //   }, 3000);
  // }

  useEffect(() => {
    // console.log(section);
    // console.log(imgBase64Data, dataEvaluacion);
    // console.log(dataEvaluacion);
    navigate('#Evaluation');
  }, [section]);

  const closeEvaluation = () => {
    navigate('/');
  };

  return (
    <>
      <Dialog open={isOpen} ref={contentRef} onClose={() => setIsOpenModalCloseDialog(true)} className="relative" style={{overflow: 'auto'}} fullScreen>
        <DialogTitle className="flex flex-row justify-around" style={{ fontWeight: 'bold' }}>
          <button className='invisible' disabled>
            <CloseIcon />
          </button>

          <p className="text-xl m-0">{control[dataEvaluacion.mes - 1]?.titulo || control[0].titulo}</p>

          <button onClick={closeEvaluation} className='font-bold'>
            <CloseIcon fontSize={isMobile ? 'medium' : 'large'} />
          </button>
        </DialogTitle>

        <DialogContent className="flex flex-col">
          <p className='self-center' id='Evaluation'>{control[dataEvaluacion.mes - 1]?.desc || control[0].desc}</p>

          <a href="#Evaluation" id='GoToTheTop'></a>

          <div className='flex flex-col justify-center items-center'>
            {section === 0 && (
              <FotosEvaluacion 
                files={files}
                user={user}
                isMobile={isMobile}
                setFiles={setFiles}
                setImgBase64Data={setImgBase64Data}
                setSection={setSection}
                sexo={sexo}
              />
            )}

            {section === 1 && (
              <PesoPorcentajeSection 
                setSection={setSection}
                dataEvaluacion={dataEvaluacion}
                currentPhase={currentPhase}
                objetivoActual={objetivoActual}
                handleChange={handleChange}
                sexo={sexo}
              />
            )}

            {section === 2 && (  
              <EntrenamientoSection
                setSection={setSection}
                dataEvaluacion={dataEvaluacion}
                handleChange={handleChange}
                sexo={sexo}
              />
            )}

            {section === 3 && (
              <ComidasSection
                setSection={setSection}
                dataEvaluacion={dataEvaluacion}
                handleChange={handleChange}
              />
            )}
          </div>

          <br />

          {section === 3 && (
            <div className="flex justify-center w-full">
              <div className="flex flex-row gap-3 self-center">
                <Tr4inerOutlinedButton
                  variant="outlined"
                  size="large"
                  sx={{
                    color: '#000',
                    textTransform: 'capitalize',
                    fontSize: '1.2rem',
                    fontWeight: 'bold',
                  }}
                  onClick={() => {
                    setSection((sec: number) => sec - 1);
                  }}
                >
                  {`Atrás`}
                </Tr4inerOutlinedButton>

                <button
                  className='bg-[#FDB600] font-bold text-[1.2rem] rounded-[4px] px-[23px] py-[9px] transition delay-150 duration-300 ease-in-out hover:-translate-y-1 hover:scale-110 hover:bg-orangeTr4iner'
                  onClick={() => abrirModalConfirmarEvaluacion({data: dataEvaluacion, user: user, files: files, sexo: sexo, setIsOpenModalConfirmar: setIsOpenModalConfirmar})}
                  disabled={disabledButton()}
                >
                  Vamos al mes { dataEvaluacion.mes ? dataEvaluacion.mes : 'siguiente' }
                </button>
              </div>
            </div>
          )}

          {isLoading && (
            <div className="absolute w-full bg-slate-900/40 h-full top-0 left-0 z-2 flex items-center justify-center">
              <Loading />
            </div>
          )}
        </DialogContent>
      </Dialog>

      {isOpenModalConfirmar && (
        <ModalConfirmarEvaluacion
          isOpen={isOpenModalConfirmar}
          setIsOpen={setIsOpenModalConfirmar}
          sendData={sendData}
        />
      )}
      {isOpenModalCloseDialog && (
        <ModalCloseDialog
          isOpen={isOpenModalCloseDialog}
          setIsOpen={setIsOpenModalCloseDialog}
        />
      )}
    </>
  );
};

export default ModalEvaluacion;
